import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CommJrnl = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.998 3H8.82c-.601 0-1.002.5-1.002 1v32c0 1.6-1.303 2.9-2.907 2.9A2.905 2.905 0 0 1 2.005 36V8.6A1.003 1.003 0 0 0 0 8.6V36c0 2.8 2.205 5 5.011 5H38.99C41.695 41 44 38.8 44 36V4.1c0-.6-.501-1.1-1.002-1.1Zm-1.103 33c0 1.6-1.303 2.9-2.906 2.9H8.92c.602-.8.902-1.8.902-2.9V5.1h32.073V36Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.084 10.6V16c0 .6-.5 1-1.002 1h-8.319c-.601 0-1.002-.5-1.002-1v-5.4c0-.6.501-1 1.002-1h8.319c.601 0 1.002.4 1.002 1ZM14.733 13.3c0-.6.502-1 1.003-1h5.212c.601 0 1.002.5 1.002 1 0 .6-.501 1-1.002 1h-5.212c-.602 0-1.003-.4-1.003-1ZM14.733 22.9c0-.6.502-1 1.003-1h20.346c.601 0 1.002.5 1.002 1 0 .6-.5 1-1.002 1H15.736c-.602 0-1.003-.4-1.003-1ZM14.733 32.4c0-.6.502-1 1.003-1h20.346c.601 0 1.002.5 1.002 1 0 .6-.5 1-1.002 1H15.736c-.602.1-1.003-.4-1.003-1Z"
  }));
});
CommJrnl.displayName = 'CommJrnl';
CommJrnl.defaultProps = {
  'aria-label': 'CommJrnl'
};
export default CommJrnl;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/CommJrnl.js
// module id = 3622
// module chunks = 11